export default __webpack_public_path__ + "static/media/tap.cima.44b69221.png";